<template>
	<div class="my_center">
		<div v-wechat-title="$route.meta.title"></div>
		<div style="display: flex;flex-direction: column; align-items: center;">
			<div style="width: 75%; height: 270px; background-color: #FFFFFF; margin-top: 0px;  padding: 20px;">
				<div style="display: flex; align-items: center; justify-content: space-between;">
					<div style="display: flex; justify-content: space-between; width: 350px;">
						<div style="position: relative;">
							<img  :src="userBaseInfo.avatar" @click="uploadAvatarModal" style="width: 110px;height110px; display: inline-block; border-radius: 50%;cursor: pointer;"/>

							<!--							<span style="position: absolute;" class="g_css">G</span>-->

						</div>
						<div style="display: flex; flex-direction: column;justify-content: space-around; margin-left: 10px">
							<div style="display: flex; justify-content: space-between; width: 200px; align-items: center;">
								<Input class="input-call" v-model="userBaseInfo.name" placeholder="请输入姓名" style="width: 120px;" />
								<span class="g_css">G</span>
								<span style="color: #00A9EA;" class="icon iconfont icon-biaojixiaoqi"></span>
								<span style="color: #FE7152;" class="icon iconfont icon-yonghufangkeshu"></span>
								<span style="color: #68C030; font-size: 22px;" class="icon iconfont icon-shouji"></span>
							</div>
							<div style="min-width: 500px;">
								<Tag closable @on-close="delUserTag" v-for="(tag,index) in userTagList" :key="index" :name="tag">{{tag}}</Tag>
							</div>
							<div style=" display: flex;">
								<Input class="input-call-phone" v-model="userTag" placeholder="请输入标签" style="width: 100px;" />
								<Button type="primary" style="margin-left: 10px;" @click="saveUserTag">添加</Button>
							</div>
						</div>
					</div>
					<!-- 表头右侧 -->
					<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; ">
						<div style="display: flex;align-items: center; justify-content: space-between;width: 180px;">
							<span style="color: #0092FF;" class="icon iconfont icon-bohao"></span>
							<Input class="input-call-phone" disabled v-model="userBaseInfo.phone" placeholder="请输入电话号" style="width: 120px;" />
							<span class="g_css">G</span>
						</div>
						<!-- 二维码 -->
						<img style="margin-top: 10px; height: 100px;" v-if="QRCode.url" :src="QRCode.url" />
						<img style="margin-top: 10px; height: 100px;" v-else src="../../assets/images/erweima.png" />
						<Button icon="ios-cloud-upload-outline" @click="uploadQRCodeModal" style="margin-top: 10px">上传二维码</Button>
					</div>
				</div>
				<div style="border-bottom: 1px dashed #C9C9C9; margin-top: 20px;"></div>
				<div style="margin-top: 15px; display: flex; justify-content: flex-end;"><Button type="primary" @click="saveUserBaseInfo">保存</Button></div>
			</div>
			<!-- 我的成就 -->
			<div class="achievement">
				<span class="title_font">我的成就0/30</span>
				<span style="font-size: 16px; color: #51B5FF; cursor: pointer;">全部成就</span>
			</div>
			<!-- 表单下方 -->
			<div class="form_bottom">
				<!-- 个人信息 -->
				<div class="flex_css" style="margin-top: 40px;">
					<span class="title_font">个人信息</span>
					<Button type="primary" @click="savePersonalInfo">保存</Button>
				</div>
				<div class="margin_top_css">
					<Row>
				        <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">姓名</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.name" style="width: 300px" />
							</div>							
						</Col>
				        <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">出生日期</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.birthdate" style="width: 300px" />
							</div>
						</Col>
						<Col span="8">
							<div class="flex_form_list">
								<div class="title_width">性别</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.sex" style="width: 300px" />
							</div>
						</Col>
				    </Row>	

					<Row>
				        <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">籍贯</div>
								<span class="colon_css">:</span>
								<Input v-model="userBaseInfo.native_place" style="width: 300px" />
							</div>							
						</Col>
				        <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">私人手机号码</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.mobile" style="width: 300px" />
							</div>
						</Col>
						<Col span="8">
							<div class="flex_form_list">
								<div class="title_width">学历</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.education" style="width: 300px" />
							</div>
						</Col>
				    </Row>	
					<Row>
					    <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">毕业院校</div>
								<span class="colon_css">:</span>
								<Input v-model="userBaseInfo.school" style="width: 300px" />
							</div>							
						</Col>
					    <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">身份证</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.id_card_number" style="width: 300px" />
							</div>
						</Col>
						<Col span="8">
							<div class="flex_form_list">
								<div class="title_width">入职时间</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.entry_time" style="width: 300px" />
							</div>
						</Col>
					</Row>
					<Row>
					    <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">上家公司名称</div>
								<span class="colon_css">:</span>
								<Input v-model="userBaseInfo.last_company" style="width: 300px" />
							</div>							
						</Col>
					    <Col span="8">
							<div class="flex_form_list">
								<div class="title_width">上家公司职务</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.last_position" style="width: 300px" />
							</div>
						</Col>
						<Col span="8">
							<div class="flex_form_list">
								<div class="title_width">贷款行业从业时间</div>
								<span class="colon_css">:</span>
								<Input v-model="personalInfo.working_time" style="width: 300px" />
							</div>
						</Col>
					</Row>
				</div>

				<!-- 影像资料 -->
				<div class="flex_css" style="margin-top: 40px;">
					<span class="title_font">影像资料</span>
					<Button type="primary" @click="saveImageInfo">保存</Button>
				</div>
				<div class="flex_form_list">
					<div class="title_width">身份证</div>
					<span class="colon_css">:</span>
					<MyUpload ref="idCard" :maxUploadCount="2"></MyUpload>
				</div>
				<div class="flex_form_list">
					<div class="title_width">执业证</div>
					<span class="colon_css">:</span>
					<MyUpload ref="certificate" :maxUploadCount="1"></MyUpload>
				</div>
				<div class="flex_form_list">
					<div class="title_width">其他<br>(征信报告，体检报告等)</div>
					<span class="colon_css">:</span>
					<MyUpload ref="other" :maxUploadCount="1"></MyUpload>
				</div>
			</div>
		</div>

		<!-- 擅长领域对话框 -->
		<Modal v-model="specialityShow"  @on-ok="specialityOk ">
			<div style="color: #000000; font-weight: bold; margin-bottom: 20px;">擅长领域</div>
			<CheckboxGroup v-model="personalInfo.skilledField">
				<Checkbox v-for="(item,index) in specialityLabel" :key='index' :label="item"></Checkbox>
			</CheckboxGroup>
		</Modal>
		<Modal
				v-model="uploadModal"
				title="上传图片"
				@on-cancel="() => {uploadModal = false}"
				@on-ok="fileOk">
			<addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
		</Modal>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue'
	import cityData from "./citydata";
	import addFile from "../tool/addFile.vue";
	import MyUpload from "../tool/Upload.vue";
	import {mapGetters} from 'vuex';
	import {
		changeUserInfo,getUserCenterInfo
	} from '@/api/user.js';

	export default {
		name: "MyCenter",

		computed:{
			...mapGetters(['userInfo', 'token'])
		},
		components: {
			TopBar,
			addFile,
			MyUpload
		},
		mounted: function () {
			if(this.$route.query.uid){
				this.uid = this.$route.query.uid;
			}
			this.getUserCenterInfo()
		},
		watch: {
			$route() { // 监听路由变化  
				if (this.$route.name == "myCenter") {
					this.uid = this.$route.query.uid
				}
			},
			uid() {
				this.getUserCenterInfo();
			},
		},
		data() {
			return {
				uploadName: '',
				uploadModal: false,
				specialityLabel:['婚姻家庭','债权债务','形事辩护'],
				specialityList:[],
				specialityShow:false,//擅长领域对话框
				hideShow: false,
				heightIndex: 120,
				uid:'',
				userBaseInfo:{
					name: '',
					phone: '',
					avatar:''//头像
				},
				synopsisValue: '', 
				imageList:[],
				userTag:'',
				userTagList:[],
				QRCode:{
					name:'',
					url:'',
				},
				// 个人信息
				personalInfo: {
					name: '',
					working_time: '',//性别
					birthdate: '',//年龄
					sex: '',//身份证
					mobile: '',//民族
					education: '',//籍贯
					native_place: '',//政治面貌
					school: '',
					entry_time: '',
					last_company: '',
					last_position: '',
					id_card_number:'',
				},
				imgInfo:{

				},
				cityData: cityData,
				// 个人数据
				myData: [{
					title: '业绩',
				}]
			}
		},


		methods: {
			pullClick() {
				this.hideShow = true
				let num = this.caseList.length
				this.heightIndex = num * 40
			},
			hideClick() {
				this.hideShow = false
				this.heightIndex = 120
			},
			formatErrorValid (file) {
				this.$Notice.warning({
					title: '文件格式错误',
					desc: '文件 ' + file.name + ' 格式错误, 请选择jpg或png图片.'
				});
			},
			uploadAvatarModal() {
				this.uploadName = 'avatar';
				this.uploadModal = true;
			},
			fileOk() {
				let that = this;
				let fileUrl = that.$refs['addFile'].fileUrl;
				if (this.uploadName == 'avatar') {
					this.uploadAvatar(fileUrl);
				} else if (this.uploadName == 'qrCode') {
					this.uploadQRCode(fileUrl);
				}
			},
			uploadAvatar (url) {
				//头像上传成功后
				this.userBaseInfo.avatar = url
				//更新个人信息
				this.saveUserBaseInfo()
			},
			specialityClick() {
				this.specialityShow = true
			},
			//添加个人标签
			saveUserTag(){
				let that = this
				if(that.userTag){
					that.userTagList.push(that.userTag);
				}
				that.userTag = '';
				let data = {token:that.token, userTagList:that.userTagList}
				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('添加成功')
					}else{
						that.$Message.warning('添加失败')
					}
				});

			},
			//删除个人标签
			delUserTag(event,name){
				let that = this
				that.userTagList.splice(that.userTagList.indexOf(name), 1);
				let data = {token:that.token, userTagList:that.userTagList}
				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('删除成功')
					}else{
						that.$Message.warning('删除失败')
					}
				});
			},

			beforeUpload(){
				this.QRCode = []
			},
			uploadQRCodeModal() {
				this.uploadName = 'qrCode';
				this.uploadModal = true;
			},
			//上传二维码
			uploadQRCode(url){
				let that = this
				that.QRCode = {
					name:'我的二维码',
					url: url
				}

				let data = {token:that.token,uid:that.uid, QRCode:that.QRCode}
				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('上传成功')
					}else{
						that.$Message.warning('上传失败')
					}
				});
			},
			handleFormatError(file){
				this.$Notice.warning({
					title: '仅支持jpg,jpeg,png格式文件',
					desc: '文件 [' + file.name + '] 格式错误.'
				});
			},
			// 擅长领域确定
			specialityOk() {

			},
			saveUserBaseInfo(){
				let that = this
				let data = {token:that.token, uid:that.uid,baseInfo:that.userBaseInfo}
				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('保存成功')
					}else{
						that.$Message.warning('保存失败')
					}
				});
			},
			//保存个人信息
			savePersonalInfo(){
				let that = this
				let data = {token:that.token,uid:that.uid,personalInfo:that.personalInfo}

				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('保存成功')
					}else{
						that.$Message.warning('保存失败')
					}
				});
			},
			//保存职业信息
			saveProfessionInfo(){
				let that = this
				let data = {token:that.token,uid:that.uid, professionInfo:that.professionInfo}

				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('保存成功')
					}else{
						that.$Message.warning('保存失败')
					}
				});
			},
			//保存影像资料
			saveImageInfo(){
				let that = this
				let idCard = that.$refs['idCard'].uploadList
				let certificate = that.$refs['certificate'].uploadList
				let other = that.$refs['other'].uploadList
				let data = {
					token:that.token,
					uid:that.uid,
					imgInfo:{
						idCardImg:idCard,
						certificateImg:certificate,
						otherImg:other,
					}
				}
				changeUserInfo(data).then(function (res){
					if(res.data.code == 1){
						that.$Message.success('保存成功')
					}else{
						that.$Message.warning('保存失败')
					}
				});
			},
			//获取用户资料
			getUserCenterInfo(){
				let that = this
				let data = {token:this.token,uid:this.uid}
				getUserCenterInfo(data).then(function (res){
					//基本信息
					that.userBaseInfo = res.data.data.userBaseInfo
					//标签信息
					if(res.data.data.userTagList.length){
						that.userTagList = res.data.data.userTagList
					}
					//二维码
					if(res.data.data.QRCode){
						that.QRCode = res.data.data.QRCode
					}
					//个人信息
					if (res.data.data.personalInfo != []) {
						that.personalInfo = res.data.data.personalInfo
						
					}
					//职业信息
					if (res.data.data.professionInfo != []) {
						that.professionInfo = res.data.data.professionInfo
					}
					//影像信息
					if (res.data.data.imgInfo != []) {
						that.imgInfo = res.data.data.imgInfo
						if(that.imgInfo.idCardImg.length){
							that.$refs['idCard'].uploadList = that.imgInfo.idCardImg
						}
						if(that.imgInfo.certificateImg.length){
							that.$refs['certificate'].uploadList = that.imgInfo.certificateImg
						}
						if(that.imgInfo.otherImg.length){
							that.$refs['other'].uploadList = that.imgInfo.otherImg
						}
					}
				});
			}
		},

	}
</script>

<style scoped lang="less">
	.my_center {
		width: 100%;
		background-color: #F5F7F9;
	}

	.input-call :nth-last-child(1) {
		font-weight: bold;
		font-size: 20px;
	}

	.g_css {
		color: red;
		font-size: 10px;
	}

	.input-call-phone :nth-last-child(1) {
		font-weight: bold;
		font-size: 16px;
	}

	.achievement {
		width: 75%;
		height: 100px;
		background-color: #FFFFFF;
		margin-top: 20px;
		padding: 20px;
		display: flex;
		justify-content: space-between;
	}

	.form_bottom {
		width: 75%;
		background-color: #FFFFFF;
		margin-top: 20px;
		padding: 20px;
		margin-bottom: 50px;
	}

	.title_font {
		font-size: 20px;
		font-weight: bold;
	}

	.lan {
		color: #5FA3FF;
		cursor: pointer;
	}

	.flex_css {
		display: flex;
		justify-content: space-between;
	}

	.margin_top_css {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.title_width {
		width: 76px;
		text-align-last: justify;
		color: #A6A4A2;
		font-weight: bold;
	}

	.flex_form_list {
		display: flex;
		align-items: center;
		width: 80%;
		margin-bottom: 15px;
	}

	.colon_css {
		font-weight: bold;
		margin-right: 5px;
	}

	.undergo {
		height: 50px;
		background-color: #F1F3F4;
		border-radius: 10px;
		margin: 10px 0;
		display: flex;
		justify-content: space-around;
		align-items: center;

		span {
			color: #687084;
			font-size: 16px;
			font-weight: bold;
		}
	}

	.case_list {
		height: 40px;
		border-radius: 10px;
		display: flex;
		align-items: center;
	}
</style>
